import { Service, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from 'app/account/user/user.model';
import { UpdateLLMSelectionDecisionDto } from 'app/account/user/shared/dto/updateLLMSelectionDecision.dto';
import { LLMSelectionDecision } from 'app/account/user/shared/dto/updateLLMSelectionDecision.dto';

@Service()
export class UserService {
    private http = inject(HttpClient);

    public resourceUrl = 'api/account/users';
    public adminResourceUrl = 'api/account/admin/users';

    /**
     * Search for a user on the server by login or name. Only administrators may search all users.
     * @param loginOrName The login or name to search for.
     * @return Observable<HttpResponse<User[]>> with the list of found users as body.
     */
    search(loginOrName: string): Observable<HttpResponse<User[]>> {
        return this.http.get<User[]>(`${this.adminResourceUrl}/search?loginOrName=${loginOrName}`, { observe: 'response' });
    }

    /**
     * Initializes an LTI user and returns the newly generated password.
     */
    initializeLTIUser(): Observable<HttpResponse<{ password: string }>> {
        return this.http.put<{ password: string }>(`${this.resourceUrl}/initialize`, null, { observe: 'response' });
    }

    /**
     * Updates the user's AI experience selection.
     */
    updateLLMSelectionDecision(selection: LLMSelectionDecision): Observable<HttpResponse<void>> {
        const updateLLMSelectionDecisionDto: UpdateLLMSelectionDecisionDto = { selection };
        return this.http.put<void>(`${this.resourceUrl}/select-llm-usage`, updateLLMSelectionDecisionDto, { observe: 'response' });
    }
}
